import React, { useState, useEffect } from "react";
import {
  DASHBOARD_SIDEBAR_BOTTOM_LINKS,
  DASHBOARD_SIDEBAR_LINKS
} from "../../lib/consts/navigation";
import { Link, useLocation } from "react-router-dom";
import classNames from "classnames/bind";
import { 
  HiOutlineLogout, 
  HiChevronDoubleLeft, 
  HiChevronDoubleRight 
} from "react-icons/hi";

const linkClasses =
  "flex items-center gap-2 font-light px-3 py-2 hover:bg-neutral-400 hover:text-neutral-900 hover:no-underline active:bg-neutral-500 rounded-sm text-base transition-colors";

const RESTRICTED_PATHS = [
  "/staffs",
  "/payment",
  "/statistics"
];

export default function Sidebar({ onLogout }) {
  const [userRole, setUserRole] = useState(null);
  const [isCollapsed, setIsCollapsed] = useState(false);

  useEffect(() => {
    const storedRole = localStorage.getItem("userRole");
    setUserRole(storedRole);
  }, []);

  return (
    <div
      className={classNames(
        "bg-neutral-300 p-3 flex flex-col text-white transition-all duration-300 relative shadow-md",
        isCollapsed ? "w-20" : "w-60"
      )}
    >
      {/* Logo & Collapse Button Header */}
      <div className="flex items-center justify-between px-1 py-3">
        {!isCollapsed && (
          <img 
            src="KE-08.png" 
            alt="Logo" 
            style={{ width: "140px", height: "40px", objectFit: "contain" }} 
          />
        )}
        <button
          onClick={() => setIsCollapsed(!isCollapsed)}
          className={classNames(
            "p-1.5 rounded-md hover:bg-neutral-400 text-black transition-colors",
            isCollapsed ? "mx-auto" : "ml-auto"
          )}
          title={isCollapsed ? "Expand Sidebar" : "Collapse Sidebar"}
        >
          {isCollapsed ? (
            <HiChevronDoubleRight className="text-xl text-black" />
          ) : (
            <HiChevronDoubleLeft className="text-xl text-black" />
          )}
        </button>
      </div>

      {/* Main links */}
      <div className="flex-1 py-6 flex flex-col gap-0.5 overflow-x-hidden">
        {DASHBOARD_SIDEBAR_LINKS.map((item) => {
          const isRestricted = RESTRICTED_PATHS.includes(item.path);

          if (isRestricted && userRole !== "boss") return null;

          return <SidebarLink key={item.key} item={item} isCollapsed={isCollapsed} />;
        })}
      </div>

      {/* Logout */}
      <button
        onClick={onLogout}
        title={isCollapsed ? "Logout" : undefined}
        className={classNames(
          linkClasses, 
          "text-neutral-900",
          isCollapsed && "justify-center px-2"
        )}
      >
        <HiOutlineLogout className="text-xl text-neutral-900 shrink-0" />
        {!isCollapsed && <span className="truncate">Logout</span>}
      </button>

      {/* Bottom links */}
      <div className="mt-2 flex flex-col gap-0.5 overflow-x-hidden">
        {DASHBOARD_SIDEBAR_BOTTOM_LINKS.map((item) => (
          <SidebarLink key={item.key} item={item} isCollapsed={isCollapsed} />
        ))}
      </div>
    </div>
  );
}

function SidebarLink({ item, isCollapsed }) {
  const { pathname } = useLocation();

  return (
    <Link
      to={item.path}
      title={isCollapsed ? item.label : undefined}
      className={classNames(
        pathname === item.path
          ? "bg-neutral-900 text-red-500"
          : "text-neutral-900",
        linkClasses,
        isCollapsed && "justify-center px-2"
      )}
    >
      <span className="text-xl shrink-0">{item.icon}</span>
      {!isCollapsed && <span className="truncate">{item.label}</span>}
    </Link>
  );
}